import { useEffect, useState } from "react";
import api from "@/lib/api";
import { motion, AnimatePresence } from "framer-motion";

export default function AnnouncementBanner() {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    api.get("/announcements").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (items.length <= 1) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % items.length), 5000);
    return () => clearInterval(t);
  }, [items]);

  if (items.length === 0) return null;
  const a = items[idx];
  const toneClass =
    a.tone === "warn" ? "bg-amber-100 text-amber-900 border-amber-200" :
    a.tone === "success" ? "bg-green-100 text-green-900 border-green-200" :
    "bg-slate-100 text-slate-800 border-slate-200";

  return (
    <div className="overflow-hidden">
      <AnimatePresence mode="wait">
        <motion.div
          key={a.id}
          initial={{ y: -16, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -16, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className={`rounded-2xl border-2 px-4 py-2.5 text-sm font-semibold flex items-center gap-2 ${toneClass}`}
          data-testid="announcement-banner"
        >
          <span className="text-lg">{a.emoji || "📣"}</span>
          <span>{a.message}</span>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
